module.exports = __webpack_public_path__ + "img/mobile-legends-bang-bang.174e0435.png";